import axios from 'axios';
import api_url from './api_url'

export default class ZSLICCampaing {

    async getZSLICCampaings(token, lang="pt-pt") {


        const response = await axios.get(`${api_url}/v1/zslic-campaign/${lang}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data;

    }    
}
 